module.exports = __webpack_public_path__ + "img/nike.22844214.png";